<template>
    <div class="roma-page-content fill-height grey lighten-4">
        <h2>Tareas por revisar</h2>

        <TaskFilter />

        <TaskList />
    </div>
</template>

<script>
import TaskFilter from "@/components/task/TaskFilter.vue";
import { mapGetters, mapActions } from "vuex";
import TaskList from "@/components/task/TaskList.vue";

export default {
    components: { TaskFilter, TaskList },
    async mounted() {
        // this.setLayout("login-layout");
        await this.actionGetInformationLesson(this.getInstitutionId);
        this.setLayout("main-layout");
    },
    computed: {
        ...mapGetters({
            layout: "getLayout",
            user: "getUserData",
            getInstitutionId: "getInstitutionId"
        })
    },
    methods: {
        ...mapActions({
            setLayout: "setLayout",
            actionGetFilterInformationLesson:
                "actionGetFilterInformationLesson",
            actionGetInformationLesson: "actionGetInformationLesson"
        })
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";
h2 {
    /*transform: translateY(7px);*/
    color: map-get($colors, "purple");
}
</style>
